<div
  [krosTooltip]="tooltipTemplate"
  [tooltipShowManually]="true"
  [position]="getDisplayedMessages() === 'error' ? 'above-left' : hintTooltipPlacement"
  [tooltipClass]="getTooltipClass()"
  #tooltip="krosTooltip"
  (mouseenter)="showTooltip()"
  (mouseleave)="closeTooltip()"
>
  @if (hasLabel) {
    <label
      [attr.for]="control?.id"
      [id]="labelId"
    >
      <ng-content select="kros-label"></ng-content>
    </label>
  }

  <div
    class="input-container"
    #inputContainer
  >
    <div
      class="kros-form-field-icon-prefix"
      [class.no-pointer-events]="!allowClickableIcon"
    >
      <ng-content select="[krosPrefix], [krosIconPrefix]"></ng-content>
    </div>

    <ng-content></ng-content>

    @if (newDesign && canShowErrorIcon()) {
      <div
        class="kros-form-field-icon-invalid no-pointer-events"
        [class.has-suffix]="hasSuffixContent()"
      >
        <i
          krosInvalidIcon
          [hasSuffix]="hasSuffixContent()"
          class="hgi hgi-stroke hgi-alert-square"
        ></i>
      </div>
    }

    <div
      class="kros-form-field-icon-suffix"
      [class.no-pointer-events]="!allowClickableIcon"
      #suffixContainer
    >
      <ng-content select="[krosSuffix], [krosIconSuffix]"></ng-content>
    </div>

    <ng-content select="kros-input-loader"></ng-content>
  </div>

  <ng-template #tooltipTemplate>
    @switch (getDisplayedMessages()) {
      @case ('error') {
        <div>
          <ng-content select="kros-input-error, [krosInputError]"></ng-content>
        </div>
      }
      @case ('hint') {
        <div>
          <ng-content select="kros-input-hint, [krosInputHint]">{{ hint() }}</ng-content>
        </div>
      }
    }
  </ng-template>
</div>

<!--<div class="error-container">-->
<!--  <ng-content select="kros-input-error, [krosInputError]"></ng-content>-->
<!--</div>-->
